export type KioskSoftwareChoice = 'plus' | 'premium' | 'existing';

interface KioskPrice {
  amount: number;
  currency_code: string;
}

export interface KioskSoftwareOption {
  id: KioskSoftwareChoice;
  location_price?: KioskPrice;
  device_price: KioskPrice;
}

export interface KioskSoftwareAddOn {
  variant_id: number;
  base_product_key: string;
  tracking_data?: Record<string, unknown>;
  kiosk_software_options?: KioskSoftwareOption[];
}

export const getKioskSoftwareAddOn = (
  addOns: Record<string, KioskSoftwareAddOn[]>,
) =>
  Object.entries(addOns).flatMap(([category, products]) =>
    products
      .filter((product) => product.base_product_key === 'sw-kiosk-k1')
      .map((product) => ({ ...product, category })),
  )[0];

export const hasKioskSoftwarePricing = (addOn?: KioskSoftwareAddOn) =>
  ['plus', 'premium', 'existing'].every((id) =>
    addOn?.kiosk_software_options?.some(
      (option) =>
        option.id === id &&
        (id === 'existing' || option.location_price) &&
        option.device_price,
    ),
  );
